import {useAppSelector} from "@Hooks/selector/useAppSelector";
import {useState} from "react";
import {
    CountAmenitySelectedType
} from "@CheckOrder/features/amenities/features/countAmenity/types/CountAmenitySelected.type";
import useUpdateLocalCountAmenityStateWhenOtherGroupsUpdate
    from "@CheckOrder/features/amenities/features/countAmenity/hooks/useUpdateLocalCountAmenityStateWhenOtherGroupsUpdate";

/**
 * Handles local count amenity state.
 */
export default function useLocalCountAmenityStates() {
    const {
        singleSelectedAmenities: previousSingleSelectedAmenities,
        returnSelectedAmenities: previousReturnSelectedAmenities,
    } = useAppSelector((state) => (state.checkOrder.ticket))

    const [singleSelectedAmenities, setSingleSelectedAmenities] = useState<Record<string, CountAmenitySelectedType>>(previousSingleSelectedAmenities || {})
    const [returnSelectedAmenities, setReturnSelectedAmenities] = useState<Record<string, CountAmenitySelectedType>>(previousReturnSelectedAmenities || {})

    useUpdateLocalCountAmenityStateWhenOtherGroupsUpdate(setSingleSelectedAmenities, setReturnSelectedAmenities)

    return {
        singleSelectedAmenities,
        setSingleSelectedAmenities,
        returnSelectedAmenities,
        setReturnSelectedAmenities,
    }
}